import { constants } from "../constants";

export const toggleSpinnerOn = () => ({ type: constants.SPINNER_ON });
export const toggleSpinnerOff = () => ({ type: constants.SPINNER_OFF });

export const setDropdownOptions = payload => ({ type: constants.SET_DROPDOWN_OPTIONS, payload });
export const setShowSubNav = payload => ({ type: constants.SHOW_SUB_NAV, payload });
